import {styled} from "@mui/material/styles"
import {Grid} from "@mui/material"
import {breakpoints} from "@next/themes"

export const StyledProductGridItem = styled(Grid, {
    shouldForwardProp: prop => prop !== "injectedAd" && !String(prop).startsWith("$"),
})<{
    injectedAd?: boolean
    $customXxl?: number
}>`
    padding: 0 0.5rem;
    min-height: var(--prod-sum-tile-min-height-md, 22rem);
    ${props => (props.injectedAd ? `text-align-last:center;` : ``)}
    @media (max-width: ${breakpoints.values.md - 1}px) {
        padding: 0 0.25rem ${props => (props.injectedAd ? `1.5rem` : `0`)} 0.25rem;
        min-height: var(--prod-sum-tile-min-height-sm, 17rem);
    }
    ${({$customXxl, injectedAd}) =>
        $customXxl &&
        `@media (min-width: ${breakpoints.values.xxl}px) {
          flex-basis: ${(100 / $customXxl) * (injectedAd ? 2 : 1)}%;
          max-width: ${(100 / $customXxl) * (injectedAd ? 2 : 1)}%;
      }`}
`

export default StyledProductGridItem
